module.exports = __webpack_public_path__ + "img/18_95.3b82ffaa.png";